import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Table, Spinner } from 'react-bootstrap';
import logo from '../jsx/components/Reports/food.jpeg';
import { useReactToPrint } from "react-to-print";

const EditRepairOrder = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
    const [repairOrder, setRepairOrder] = useState([]);
    const [MainOrder, setMainOrder] = useState({});
    const [loading, setLoading] = useState(true);
    const { repairOrderId } = useParams();
    const [company, setcompany] = useState([]);
    useEffect(() => {
      const companydata = localStorage.getItem('companies');
      if (companydata) {
        const parsedData = JSON.parse(companydata);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setcompany(singleCompany); // Set state to a single object
      }
    }, []);
    const componentRef = useRef(null);
    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Userdata",
       });
    const fetchRepairOrder = async () => {
        try {
            const response = await axios.get(`https://subk.education.com.ly/back/api/maintainreport/${repairOrderId}`);
            setRepairOrder(response.data.RepairOrder.repair_details || []);
            setMainOrder(response.data.RepairOrder || {});
            setLoading(false);
        } catch (error) {
            console.error('Error fetching repair order:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchRepairOrder();
    }, []);

    const { customer, vehicle, TotalCost, RepairDate, Status, RestAmount } = MainOrder;

    if (loading) {
        return (
            <div className="text-center">
                <Spinner animation="border" />
                <p>جاري تحميل البيانات...</p>
            </div>
        );
    }
  
    
    return (
        <div className="container-fluid">

        <div className="row">
          <div className="col-lg-12">
            <div className="card mt-3">
            <Link to='/Orderslist' style={{ padding :"30px" ,display: 'flex', alignItems: 'center', position: 'absolute', left: '0px' }}>
  رجوع
  <i className="fa-solid fa-circle-arrow-left  me-3  fa-2xl"></i>
</Link>
        <div className="card-body" ref={componentRef} dir="rtl">
            {/* Logo */}
            <div className="row mx-3">
                    <div className="col-xl-12 text-center row">
                    <div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      }}>  <div 
    style={{
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
                    <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                   <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter'}}>{company.Description}</h2>  </div>
                   <div className="d-flex">                  
                   <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> تقرير صيانة سيارة</h2>
 </div> </div>

 <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "100px", width: "150px",  marginTop: '-10px',   marginLeft:'30px' }} />                     </div>
                  </div> 
                  </div> 

            {/* Customer and Vehicle Details */}
            <table className="table table-bordered">
        <tbody>
          {/* Repair Date */}
          <tr>
          <td><strong >تاريخ اصدار التقرير:</strong> {formatDate(currentDate)}</td>

            <td ><strong>  تاريخ عملية الصيانه: </strong> {RepairDate || 'غير متوفر'}</td>
            <td><strong >  اسم الزبون: </strong> {customer?.FirstName || ''} {customer?.LastName || ''}</td>
            <td><strong>الهاتف  : </strong> {customer?.Phone || ''}</td>

          </tr>

          {/* Customer Details */}
         
          <tr>
          <td><strong> النوع:</strong> {vehicle?.make.MakeName || 'غير متوفر'}</td>
          <td><strong> الموديل  :</strong> {vehicle?.vehicle_model.ModelName || 'غير متوفر'}</td>
          <td><strong>السنه:</strong> {vehicle?.Year || 'غير متوفر'}</td>
            <td><strong>رقم اللوحة:</strong> {vehicle?.LicensePlate || 'غير متوفر'}</td>
          </tr>
          <tr>
            <td><strong>اللون:</strong> {vehicle?.Color || 'غير متوفر'}</td>
            <td><strong>رقم الهيكل:</strong> {vehicle?.ChassisNumber || 'غير متوفر'}</td>
            <td><strong>رقم المحرك:</strong> {vehicle?.EngineNumber || 'غير متوفر'}</td>
            <td><strong>العداد:</strong> {vehicle?.Odometer || 'غير متوفر'}</td>
          </tr>
          <tr>
            <td><strong>نوع الزيت:</strong> {vehicle?.VehicleType || 'غير متوفر'}</td>
            <td><strong>نوع المحرك:</strong> {vehicle?.EngineType || 'غير متوفر'}</td>
            <td><strong>بلد الاستيراد:</strong> {vehicle?.ImportCountry || 'غير متوفر'}</td>
            <td><strong>ملاحظات:</strong> {vehicle?.Notes || 'غير متوفر'}</td>

          </tr>
          
        </tbody>
      </table>

            {/* Repair Details */}
            <div className="col-xl-12">
                <h4>تفاصيل الصيانة</h4>
                {repairOrder.length > 0 ? (
                    <Table bordered>
                         <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                            <tr>
                                <th>الخدمة/القطعة</th>
                                <th>الفني</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {repairOrder.map((detail, index) => (
                                <tr key={index}>
                                    <td>  {detail.service?.ServiceName ? `الخدمة : ${detail.service?.ServiceName} ` : detail.parts?.PartName ? `القطعة : ${detail.parts?.PartName} `: 'غير متوفر'}</td>
                                    <td>{detail.technician?.FirstName	 || 'غير متوفر'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>لا توجد تفاصيل صيانة متوفرة.</p>
                )}
            </div>

            {/* Summary */}
          
            </div> </div> </div> 
            <div className="modal-footer">
              <button className="btn btn-success" onClick={generatePDF}>طباعه</button>
          </div></div> </div>
    );
};

export default EditRepairOrder;
